// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/proposal_reviews.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AddReviewFindingRequest, AddReviewFindingResponse, CloseProposalReviewRequest, CloseProposalReviewResponse, CreateProposalReviewRequest, CreateProposalReviewResponse, GetProposalReviewRequest, GetProposalReviewResponse, GetSectionReviewStatesRequest, GetSectionReviewStatesResponse, ListProposalReviewsRequest, ListProposalReviewsResponse, PinReviewMaterialsRequest, PinReviewMaterialsResponse, UpdateProposalReviewRequest, UpdateProposalReviewResponse } from "./proposal_reviews_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * ProposalReviewService is the browser edge for SAD-552 / PROP-12: configurable
 * review sessions on a proposal, pinned to exact section versions. A session
 * has a name, dates, reviewers and a section scope; reviewing pins a locked
 * (kind=review) version of each section as a material, findings attach to the
 * session or a material, and closing records an outcome after which the
 * session is history (read-only).
 *
 * Identity: tenant and acting user come from the gateway principal only —
 * no request field carries them. Authorization is project membership: read
 * for the List/Get/state RPCs, write (any role but view_only) for every
 * mutation. A caller without read access gets PermissionDenied and no names,
 * counts or states; authorization runs before pangaea is called.
 *
 * @generated from service mono.projectdata.v1.ProposalReviewService
 */ export const ProposalReviewService = {
    typeName: "mono.projectdata.v1.ProposalReviewService",
    methods: {
        /**
     * @generated from rpc mono.projectdata.v1.ProposalReviewService.ListProposalReviews
     */ listProposalReviews: {
            name: "ListProposalReviews",
            I: ListProposalReviewsRequest,
            O: ListProposalReviewsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProposalReviewService.GetProposalReview
     */ getProposalReview: {
            name: "GetProposalReview",
            I: GetProposalReviewRequest,
            O: GetProposalReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProposalReviewService.CreateProposalReview
     */ createProposalReview: {
            name: "CreateProposalReview",
            I: CreateProposalReviewRequest,
            O: CreateProposalReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * UpdateProposalReview replaces the configuration of an open review.
     *
     * @generated from rpc mono.projectdata.v1.ProposalReviewService.UpdateProposalReview
     */ updateProposalReview: {
            name: "UpdateProposalReview",
            I: UpdateProposalReviewRequest,
            O: UpdateProposalReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * PinReviewMaterials locks each section's current head as a review version
     * labelled with the session name (the PROP-07 snapshot) and pins it to the
     * session. A section with no text fails the call with FailedPrecondition
     * naming it; sections are validated before any is pinned.
     *
     * @generated from rpc mono.projectdata.v1.ProposalReviewService.PinReviewMaterials
     */ pinReviewMaterials: {
            name: "PinReviewMaterials",
            I: PinReviewMaterialsRequest,
            O: PinReviewMaterialsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProposalReviewService.AddReviewFinding
     */ addReviewFinding: {
            name: "AddReviewFinding",
            I: AddReviewFindingRequest,
            O: AddReviewFindingResponse,
            kind: MethodKind.Unary
        },
        /**
     * CloseProposalReview is idempotent. outcome is required.
     *
     * @generated from rpc mono.projectdata.v1.ProposalReviewService.CloseProposalReview
     */ closeProposalReview: {
            name: "CloseProposalReview",
            I: CloseProposalReviewRequest,
            O: CloseProposalReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetSectionReviewStates reports whether each section's current content has
     * been reviewed, and whether it changed since.
     *
     * @generated from rpc mono.projectdata.v1.ProposalReviewService.GetSectionReviewStates
     */ getSectionReviewStates: {
            name: "GetSectionReviewStates",
            I: GetSectionReviewStatesRequest,
            O: GetSectionReviewStatesResponse,
            kind: MethodKind.Unary
        }
    }
};
